interface PromiseConstructor {
    all(values: any);
}

namespace Matrix.Visualizer {

    export class GraphDataStore {
        private data?: GraphDataResponse[];
        private fetchQueue: GraphDataRequest[] = [];

        constructor() {
            this.data = [];
        }

        public getData(request: GraphDataRequest, onSuccess?: (response: GraphDataResponse) => void) {

            const [el] = this.data.filter(x => x.GraphInstanceId === request.GraphInstanceId);
            if (el) {
                if (onSuccess) {
                    onSuccess(Q.deepClone(el));
                }
            }
            else {
                if (!this.fetchQueue.some(x => x.GraphInstanceId === request.GraphInstanceId)) {
                    this.fetchQueue.push(request);

                    VisualizerService.Retrieve(
                        request,
                        (result: GraphDataResponse) => {

                            this.fetchQueue.splice(this.data.indexOf(request), 1);
                            this.setData(result);

                            if (onSuccess) {
                                onSuccess(Q.deepClone(result));
                            }
                        });

                }
            }
        }

        public getInstances(graphKey: string, themeKey: string) {
            const data = this.data.filter(x => x.GraphKey === graphKey && x.ThemeKey == themeKey);
            return Q.deepClone(data);
        }

        public setData(data: GraphDataResponse) {
            const [el] = this.data.filter(x => x.GraphInstanceId === data.GraphInstanceId);
            if (el) {
                this.data.splice(this.data.indexOf(el), 1);
            }

            this.data.push(data);
        }

        public preload(intances: GraphInstanceRow[]) {
            setTimeout(() => {

                let promiseArr = intances.map((i) => {
                    let request: GraphDataRequest = {
                        GraphInstanceId: i.GraphInstanceId,
                        InstanceKey: i.InstanceKey,
                        ThemeKey: i.ThemeKey,
                        GraphKey: i.GraphKey
                    };

                    this.getData(request);
                });

                Promise.all(promiseArr);

            }, 0);
        }
    }
}